import { getLabelMessage } from '@gef-ui/localization/messages';
import { useCallback } from 'react';
import { showErrorSingle } from '../../actions';
import { useErrorDispatch } from '../../context';
const useHandleConfigError = ()=>{
    const errorDispatch = useErrorDispatch();
    const handleErrorLogout = useCallback((error)=>{
        errorDispatch(showErrorSingle({
            heading: getLabelMessage('errors:configJsonErrorHeading'),
            shortDescription: getLabelMessage('errors:configJsonErrorDescription'),
            longDescription: error?.message || error,
            screen: 'CONFIG'
        }));
    }, [
        errorDispatch
    ]);
    return handleErrorLogout;
};
export default useHandleConfigError;
